import React from 'react';
import fire from '../../img/fire.png'
import hot1 from '../../img/hot1.png';
import hot2 from '../../img/hot2.png';
import lieeI from '../../img/logoLL.png';
// import { BsArrowUpShort } from "react-icons/bs";
import { BsArrowUpShort } from "react-icons/bs";
import { GoPrimitiveDot } from "react-icons/go";
import { FaHandPointRight } from "react-icons/fa";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Link } from "react-router-dom";
const hotList = [
    {
        id: 0,
        image: hot1,
        title: 'VFT / USDT',
        usdt: '$0.0004938',
        pars: '2.72%',
    },
    {
        id: 1,
        image: lieeI,
        title: 'VFT / USDT',
        usdt: '$0.002206',
        pars: '3.18%',
    },

];
const hotList2 = [
    {
        id: 0,
        image: hot1,
        title: 'VFT / USDT',
        usdt: '$0.0004938',
        pars: '2.72%',
        active: 'active'
    },
    {
        id: 1,
        image: lieeI,
        title: 'VFT / USDT',
        usdt: '$0.002206',
        pars: '3.18%',
        active: 'active'
    },
    {
        id: 2,
    },
    {
        id: 3,
    },
    {
        id: 4,
    },

];

const presalesData = [
    {
        id: "0",
        image: hot1,
        lists: 'Listed on DEX',
        title: 'ValueFinance',
        tag: [
            'audit',
            'team kyc',
            'contract',
        ],
        title2: 'IDO Sale',
        progress: 100,
        busd: '1300',
        vft: 1300,
        softCap: '800 BNB',
        hardCap: '1300 BNB',
        liquidity: '60%',
        lockTime: '1 year',
        listingTime: '00:00:00',
    },
    {
        id: "2",
        image: hot2,
        lists: 'Upcoming',
        title: 'CloudPet Token',
        tag: [
            'audit',
            'team kyc',
            'contract',
        ],
        title2: 'IDO Sale',
        progress: 0,
        busd: '0',
        vft: 0,
        softCap: '25k busd',
        hardCap: '50k busd',
        liquidity: '60%',
        lockTime: '1 year',
        listingTime: 'After IDO',
    }, 


];


const Launchpad = () => {
    return (
        <div className='launchpad-area'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="hot-list-content">
                            <div className="hot-title">
                                <img src={fire} alt="icon" />
                                <span>HOT</span>
                            </div>
                            <div className="hot-items">
                                {hotList.map((item) => (
                                    <div className="hot-item">
                                        <img src={item.image} width={50} alt="logo" />
                                        <div className="text text-end">
                                            <a href='#' className="h6">{item.title}</a>
                                            <span>{item.usdt} <BsArrowUpShort /></span>
                                            <div className="h6"> 🔥 {item.pars}</div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12">
                        <div className="items-tags">
                            <div className="hot-items">
                                {hotList2.map((item) => (
                                    <div className="hot-item" id={item.active}>
                                        <img src={item.image} width={70} alt="logo" />
                                        <div className="text text-end">
                                            <a href='#' className="h6">{item.title}</a>
                                            <span>{item.usdt} <BsArrowUpShort /></span>
                                            <div className="h6"> 🔥 {item.pars}</div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="presales-content">
                            <div className="h2 title text-white fw-semibold">AVNPad Presales</div>
                            {presalesData.map((item) => (
                                <div className="presales-item" key={item.id}>
                                    <div className="presales-head d-inline-flex align-items-center gap-3">
                                        <Link to='details'><img src={item.image} width={70} alt="logo" /></Link>
                                        <div className="text text-end ms-auto">
                                            <div className="li fs-5 text-c fw-light"><GoPrimitiveDot />{item.lists}</div>
                                            <Link to='details'><div className="h4 text-white fw-semibold pt-3 mb-1">{item.title}</div></Link>
                                            <ul className='d-flex gap-2'>
                                                {item.tag.map((list) => (
                                                    <><li><a href="#">{list}</a></li></>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="presales-sale">
                                        <div className="h4 text-white fw-light">{item.title2}</div>
                                        <div className="presales-progress">
                                            <span className='text-c fs-13'>Progress {item.progress}%</span>
                                            <ProgressBar now={item.progress} />
                                            <div className="d-flex">
                                                <div className='text-2 fs-13'>{item.busd} BUSD </div>
                                                <div className='text-white ms-auto fs-13'><span className='text-c'>{item.vft} / </span> {item.hardCap} </div>
                                            </div>
                                        </div>
                                        <ul>
                                            <li>Soft Cap: <span className='text-c fw-semibold'>{item.softCap}</span> </li>
                                            <li>Liquidity: <span className='text-c fw-semibold'>{item.liquidity}</span> </li>
                                            <li>Lock Time: <span className='text-c fw-semibold'>{item.lockTime}</span> </li>
                                        </ul>
                                    </div>
                                    <hr />
                                    <div className="presales-footer">
                                        <p className='text-white fs-13 fw-light'>Listing Time: <span className='text-c'>{item.listingTime}</span> </p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
                <div className="row my-5 py-4">
                    <div className="col-lg-12">
                        <div className="call-to-action text-center">
                            <div className="h2 text-c fw-semibold pb-5 mb-3">Want to Launch Your Project on AVNPad?</div>
                            <a href='https://docs.google.com/forms/d/e/1FAIpQLSf3eKvAqiiNi4CCDcVi5-uMavPnjjgWZVDOfdK9HBLrLd0xpg/viewform' className='btn-lg'><FaHandPointRight /> apply to launch</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Launchpad
